import React from "react";
import PropTypes from "prop-types";
import { FORMER_MAX_WIDTH } from "utils/constants/ui";
import ProductFeaturesTable from "./ProductFeaturesTable";
import ProductsFeatureComparisonTable from "./ProductsFeatureComparisonTable";

const FeatureComparisonTable = ({ title, header, groups }) => {
  const groupsPresent = groups.length;
  const containerProps = {
    style: { maxWidth: FORMER_MAX_WIDTH }
  };

  if (groupsPresent) {
    const thWidth = 30;
    const tdWidth = (100 - thWidth) / header.length;

    const tableInput = {
      thWidth,
      activeIndex: 1,
      tdWidth,
      header,
      groups
    };

    return (
      <div {...containerProps} className="w-100">
        {title && (
          <div className="f2 pt5 pb4 pb5-ns fw5 ph3 ph0-ns lh-title">
            {title}
          </div>
        )}
        {/* Desktop */}
        <div className="dn dt-ns w-100 ph3">
          <ProductsFeatureComparisonTable {...tableInput} />
        </div>
        {/* Mobile */}
        <div className="db dn-ns">
          <ProductFeaturesTable {...tableInput} />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

FeatureComparisonTable.propTypes = {
  title: PropTypes.string,
  header: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
      title: PropTypes.string
    })
  ),
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          accessor: PropTypes.string
        })
      ),
      rows: PropTypes.array
    })
  )
};

export default FeatureComparisonTable;
